import { BLOCKS, INLINES } from '@contentful/rich-text-types'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'

export interface FAQ {
  title: string
  description: RichTextDocument
}

export const faqs: FAQ[] = [
  {
    title: `How can I estimate my MTUs?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `To get an idea of your MTU count, add your monthly active users to the number of anonymous visitors you get per month. Some tools also call this metric "Monthly Unique Visitors."`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Is there a free trial of the paid plans?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: `Yes! There is a 14-day free trial for the Team plan. To try the Business plan, please `,
                  nodeType: `text`,
                },
                {
                  data: {
                    uri: `/demo/`,
                  },
                  content: [
                    {
                      data: {},
                      marks: [],
                      value: `contact us`,
                      nodeType: `text`,
                    },
                  ],
                  nodeType: INLINES.HYPERLINK,
                },
                {
                  data: {},
                  marks: [],
                  value: `.`,
                  nodeType: `text`,
                },
              ],
              nodeType: BLOCKS.PARAGRAPH,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Does Segment handle billing for my Sources or Destinations services?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `No, you’re responsible for accounts that you register with Sources, Integrations, and Warehouse providers, whether they are paid or free.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `What is the benefit of an annual plan?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `If you are on the monthly billing plan, your bill may fluctuate each month based on your user activity. The annual plan allows you to purchase MTU at a lower rate. Exceeding the allotted MTU count on annual plans may incur additional charges.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `Do I need to have a data warehouse to use Warehouses?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `Yes! Segment connects to your existing data warehouse and pipes in data collected from your Sources. You don't have to worry about the ETL or maintaining the data pipeline.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
  {
    title: `How can I buy Protocols, Unify or Twilio Engage?`,
    description: {
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: `Protocols, Unify and Twilio Engage are offered as an add-on to your Segment plan. `,
              nodeType: `text`,
            },
            {
              data: {
                uri: `/demo/`,
              },
              content: [
                {
                  data: {},
                  marks: [],
                  value: `Contact us`,
                  nodeType: `text`,
                },
              ],
              nodeType: INLINES.HYPERLINK,
            },
            {
              data: {},
              marks: [],
              value: ` to learn more about what plan is best for you.`,
              nodeType: `text`,
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      data: {},
      nodeType: BLOCKS.DOCUMENT,
    },
  },
]
